import { z } from 'zod';

export const careerTrackLevelSchema = z.object({
    description: z.string(),
    level: z.number().int().min(1),
    name: z.string(),
});

export type CareerTrackLevel = z.infer<typeof careerTrackLevelSchema>;

export const careerTrackSchema = z.object({
    id: z.uuid(),
    description: z.string(),
    levels: careerTrackLevelSchema.array(),
    name: z.string(),
});

export type CareerTrack = z.infer<typeof careerTrackSchema>;
